import { BarChart, PieChart, LineChart } from 'echarts/charts';
import {
  GridComponent,
  GridSimpleComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  LegendScrollComponent,
  MarkLineComponent,
  GraphicComponent,
  DataZoomComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';

echarts.use([
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  LegendScrollComponent,
  CanvasRenderer,
  SVGRenderer,
  MarkLineComponent,
  BarChart,
  PieChart,
  LineChart,
  GraphicComponent,
  DataZoomComponent,
  GridSimpleComponent,
  TitleComponent,
  LabelLayout,
  UniversalTransition,
]);

export const { init } = echarts;
